module.exports = __webpack_public_path__ + "static/media/SymposiumHomeDesktop.960c37ab.png";